module.exports = __webpack_public_path__ + "static/media/fig_6a.bb06cc01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_6a.jpg
// module id = 677
// module chunks = 0